import { render } from "./MdTable.vue?vue&type=template&id=00c35fa4"
import script from "./MdTable.vue?vue&type=script&lang=js"
export * from "./MdTable.vue?vue&type=script&lang=js"

import "./MdTable.vue?vue&type=style&index=0&id=00c35fa4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__